// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./IconBackgroundTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IconBackground-module__Grey__mEMYg {
    background-color: var(--ds-icon-background-bg-color-gray);
}

.IconBackground-module__Red__IVNXS {
    background-color: var(--ds-icon-background-bg-color-red);
}

.IconBackground-module__Orange__wZfw8 {
    background-color: var(--ds-icon-background-bg-color-orange);
}

.IconBackground-module__Green__ByZu2 {
    background-color: var(--ds-icon-background-bg-color-green);
}

.IconBackground-module__Indigo__wKg19 {
    background-color: var(--ds-icon-background-bg-color-indigo);
}

.IconBackground-module__Pink__OVJDB {
    background-color: var(--ds-icon-background-bg-color-pink);
}

.IconBackground-module__Small__E5xrQ {
    width: var(--ds-l);
    height: var(--ds-l);
}

.IconBackground-module__Medium__SU1qV {
    width: var(--ds-9x);
    height: var(--ds-9x);
}

.IconBackground-module__Large__aFk9W {
    width: var(--ds-3xl);
    height: var(--ds-3xl);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Grey": `IconBackground-module__Grey__mEMYg`,
	"Red": `IconBackground-module__Red__IVNXS`,
	"Orange": `IconBackground-module__Orange__wZfw8`,
	"Green": `IconBackground-module__Green__ByZu2`,
	"Indigo": `IconBackground-module__Indigo__wKg19`,
	"Pink": `IconBackground-module__Pink__OVJDB`,
	"Small": `IconBackground-module__Small__E5xrQ`,
	"Medium": `IconBackground-module__Medium__SU1qV`,
	"Large": `IconBackground-module__Large__aFk9W`
};
export default ___CSS_LOADER_EXPORT___;
